// True from the load of the page until the player picks the casters of the
// first match. Garrett, 2026-10-13: "fix the entry flow so it doesnt start a
// game until wizards are chosen". The game store always holds a match, so a
// match with drawn casters is in it for that time. Nobody plays it: the board
// is not quiet, the save does not write it, and the caster select does not
// close without a pick.

import { createStore } from '../lib/store';

export const matchWaitStore = createStore<boolean>(false);

export const isMatchWaiting = (): boolean => matchWaitStore.get();
